import styled, { css } from 'styled-components';
import { FONTS, SIZE } from '@app/src/ui';

interface Props {
  bgColor?: string;
}

export const TitleText = styled.h1`
  font-family: ${FONTS.ARISTOTELICA};
  font-weight: 500;
  font-size: 22px;
  margin-bottom: 15px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 30px;
    line-height: 33px;
  }
`;

export const About = styled.p`
  font-size: 11px;
  line-height: 24px;
  font-weight: 600;
  font-family: ${FONTS.OPEN_SANS};
  border-radius: 4px;
  padding: 0px 9px;
  margin: -15px 0 25px 0;
  ${(props: Props) => props.bgColor && css`
    background: rgba(${props.bgColor},.2);
  `}

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 13px;
    line-height: 20px;
  }
`;
